import {
  RELATIVE_DATE_OPERATORS,
  TEXTFIELD_FOR_PICKLIST_OPERATORS,
} from '../SweepFieldsOperatorSelector/SweepFieldsOperatorSelector';
import { ApiSweepFieldOperator } from '../SweepFieldsOperatorSelector/sweepFieldsTypesAndOperators';
import { SfdcDisplayType } from '../../types/fields';

export const getParentFieldTypeByOperator = (
  parentFieldType: SfdcDisplayType,
  _operator?: ApiSweepFieldOperator | '',
): SfdcDisplayType => {
  //Displaying number value selector for date fieldtype
  if (_operator && RELATIVE_DATE_OPERATORS.includes(_operator)) {
    return SfdcDisplayType.NUMBER;
  }

  if (
    _operator &&
    TEXTFIELD_FOR_PICKLIST_OPERATORS.includes(_operator) &&
    [SfdcDisplayType.PICKLIST, SfdcDisplayType.MULTIPICKLIST, SfdcDisplayType.COMBOBOX].includes(
      parentFieldType,
    )
  ) {
    return SfdcDisplayType.STRING;
  }

  return parentFieldType;
};
